'use strict';

WebphoneUI.prototype.translate = function(key) {

    var translatorMessages = {
        'T_Login': 'Вход',
        'T_Outgoing': 'Исходящий вызов',
        'T_Settings': 'Настройки',

        'F_Username': 'SIP',
        'F_Password': 'Пароль',

        'B_Login': 'Войти',
        'B_Cancel': 'Отмена',

        'B_Call': 'Позвонить',
        'B_Hangup': 'Отбой',
        'B_Clear': 'C',

        'B_Logout': 'Выйти',

        'P_Status_Talk'       : 'разговор',
        'P_Status_Transfer'   : 'перевод',
        'P_Status_Hold'       : 'ожидание',
        'P_Status_Done'       : 'Разговор окончен',
        'P_Status_CallFailed' : 'Не дозвонились',
        //'P_Status_OurCancel'  : 'Вызов отменен',
        //'P_Status_OtherCancel' : 'Сброс (линия)',
        'P_Status_Calling'    : 'Идет дозвон',

        'T_Incoming': 'Входящий вызов',
        'P_Incoming': 'Входящий вызов с номера ',

        'T_History': 'История вызовов',
        'T_HistoryTitleIncoming': 'Входящий вызов',
        'T_HistoryTitleIncomingNumber': 'с номера',
        'T_HistoryTitleOutgoing': 'Исходящий вызов',
        'T_HistoryTitleOutgoingNumber': 'на номер',
        'T_HistoryTitleMissed': 'Пропущенный вызов',
        'T_HistoryTitleMissedNumber': 'с номера',
        'T_HistoryTitleCancelled': 'Отмененный вызов',
        'T_HistoryTitleCancelledNumber': 'на номер',
        'T_HistoryTitleDuration': 'длительностью',
        'T_HistoryTitleTime': 'время вызова',
        'BT_HistoryCall': 'Позвонить',

        'B_Accept': 'Принять',
        'B_Reject': 'Отклонить',

        'T_Transfer': 'Перевод звонка',
        'P_Transfer': 'Укажите номер на который нужно перевести звонок',

        'B_TransferAttended': 'С сопровождением',
        'B_TransferBlind': 'Без сопровождения',
        'B_TransferFinish': 'Завершить',

        'F_DebugMode': 'Режим отладки',

        'T_AllowAudio': 'Разрешить звук',
        'P_AllowAudio': 'Настройки браузера требуют, чтобы вы разрешили проигрывание звука своим действием. Нажмите "включить", чтобы разрешить звук.',
        'B_Enable': 'Включить',

        'B_Line1' : 'Линия 1',
        'B_Line2' : 'Линия 2',
        'B_Line3' : 'Линия 3',

        'RegistractionCause_Authentication Error': 'Ошибка авторизации.<br>Проверьте логин и пароль.',
        'RegistractionCause_Rejected': 'Ошибка авторизации.<br>Проверьте логин и пароль.',

        'CallCause_Canceled': 'Вызов отменен',
        'CallCause_No Answer': 'Нет ответа',
        'CallCause_Not Found': 'Номер не найден',
        'CallCause_Terminated': 'Вызов завершен',
        'CallCause_Rejected': 'Вызов сброшен',
        'CallCause_Incompatible SDP': 'Ошибка согласования соединения',
        'CallCause_WebRTC Error': 'Ошибка согласования соединения',

        'UserMediaException_NotAllowedError': 'Нет доступа к микрофону',

        'E_Unknown': 'Неизвестная ошибка',
        'E_NotRegistered': 'Залогиньтесь перед выполнением звонка',
        'E_RegistrationNeeded': 'Залогиньтесь перед выполнением звонка',
        'E_CalleeIsEmpty': 'Номер не указан',
        'E_CalleeIsNotNumber': 'Номер должен содержать только цифры',
        'E_NoAccessMicrophone': 'Нет доступа к микрофону',
        'E_WebSocketFailed': 'Ошибка установки соединения по websocket, проверьте доступ к URL: ',
        'E_NoFreeVLine': 'Все 3 линии заняты',
        'E_InvalidParams': 'Некорректные параметры при вызове функции',
        'E_InvalidTransferDestination': 'Некорректный параметр назначения перевода звонка',
        'E_InvalidSessionState': 'Некорректный статус сессии',

        'M_Registration': 'Успешный вход',
        'M_Calling': 'Идет вызов ...',
        'M_CallEnded': 'Вызов завершен',
    };

    if (translatorMessages[key] != undefined) {
	return translatorMessages[key];
    } else {
	return key;
    }
};
